import React, { FC, useEffect, useState } from "react";
import { PDFViewer, PDFViewerTool } from "@progress/kendo-react-pdf-viewer";
import { useParams } from "react-router";
import {
	getPdfApi,
	getPickListReportApi,
	getSoldFrozenWeeklyReportApi,
	getSoldFrozenDailyReportApi,
	getPurchaseStatisticsReportApi,
	getSalesNoteListReportApi,
	getSoldFreshReportApi,
	getSalesNoteJournalReportApi,
} from "api/pdf";
import { PickListFilter } from "api/pickList";
import { SalesNoteJournalFilter } from "api/sales";
import { SalesNoteFilter } from "api/salesNote";
import { useInfoStore } from "store/error";
import { Loader } from "@progress/kendo-react-indicators";

const tools: PDFViewerTool[] = [
	"pager",
	"spacer",
	"zoomInOut",
	"zoom",
	"selection",
	"spacer",
	"search",
	"download",
	"print",
];

export const PdfViewer: FC<{}> = ({ }) => {
	const { id, type, guid } = useParams();
	const [pdfData, setPdfData] = useState<string>();
	const [loading, setLoading] = useState<boolean>(false);
	const { setError } = useInfoStore();
	const [filterOptions, setFilterOptions] = useState<PickListFilter>({
		take: 999999,
		skip: 0,
	});

	useEffect(() => {
		if (type !== null && type !== undefined) {
			const storedFromDate = localStorage.getItem("fromDate");
			const storedToDate = localStorage.getItem("toDate");
			filterOptions.fromDate = storedFromDate ? new Date(storedFromDate) : undefined;
			filterOptions.toDate = storedToDate ? new Date(storedToDate) : undefined;
			filterOptions.buyerId = localStorage.getItem("buyerId") ?? undefined;
			filterOptions.vesselId = localStorage.getItem("vesselId") ?? undefined;
			filterOptions.vesselRegistrationNumber = localStorage.getItem("vesselRegistrationNumber") ?? undefined;
			filterOptions.fishingGearCode = localStorage.getItem("vesselRegistrationNumber") ?? undefined;
			filterOptions.catchAreaCode = localStorage.getItem("vesselRegistrationNumber") ?? undefined;

			if (type === "1") {
				setLoading(true);
				getPickListReportApi(filterOptions)
					.then((response) => { setPdfData(response); })
					.catch((err) => {
						setError(err?.response?.data ? err.response.data.returnText : err.message);
					})
					.finally(() => { setLoading(false); });
			}
			else if (type === "2") {
				setLoading(true);
				getSoldFrozenWeeklyReportApi(filterOptions)
					.then((response) => { setPdfData(response); })
					.catch((err) => {
						setError(err?.response?.data ? err.response.data.returnText : err.message);
					})
					.finally(() => { setLoading(false); });
			}
			else if (type === "3") {
				setLoading(true);
				getSoldFrozenDailyReportApi(filterOptions)
					.then((response) => { setPdfData(response); })
					.catch((err) => {
						setError(err?.response?.data ? err.response.data.returnText : err.message);
					})
					.finally(() => { setLoading(false); });
			}
			else if (type === "4") {
				setLoading(true);
				getPurchaseStatisticsReportApi(filterOptions)
					.then((response) => { setPdfData(response); })
					.catch((err) => {
						setError(err?.response?.data ? err.response.data.returnText : err.message);
					})
					.finally(() => { setLoading(false); });
			}
			else if (type === "5") {
				setLoading(true);
				getSoldFreshReportApi(filterOptions)
					.then((response) => { setPdfData(response); })
					.catch((err) => {
						setError(err?.response?.data ? err.response.data.returnText : err.message);
					})
					.finally(() => { setLoading(false); });
			}
			else if (type === "6") {
				setLoading(true);
				const journalFilter: SalesNoteJournalFilter = {
					dateFrom: storedFromDate ? new Date(storedFromDate) : undefined,
					dateTo: storedToDate ? new Date(storedToDate) : undefined,
					byerLedgerAccount: localStorage.getItem("byerLedgerAccount") ? Number(localStorage.getItem("byerLedgerAccount")) : undefined,
					terminal: localStorage.getItem("terminal") ?? undefined,
					species: localStorage.getItem("species") ?? undefined,
					fishingGearCode: localStorage.getItem("fishingGearCode") ?? undefined,
					catchField1: localStorage.getItem("catchField1") ?? undefined,
					catchField2: localStorage.getItem("catchField2") ?? undefined,
					conditionCode: localStorage.getItem("conditionCode") ?? undefined,
					preservationCode: localStorage.getItem("preservationCode") ?? undefined,
					fishermanLedgerAccount: localStorage.getItem("fishermanLedgerAccount") ?? undefined,
					orderBy: localStorage.getItem("orderBy") ?? undefined,
				};
				getSalesNoteJournalReportApi(journalFilter)
					.then((response) => { setPdfData(response); })
					.catch((err) => {
						setError(err?.response?.data ? err.response.data.returnText : err.message);
					})
					.finally(() => { setLoading(false); });
			}
			else if (type === "7") {
				setLoading(true);
				getSalesNoteListReportApi(filterOptions)
					.then((response) => { setPdfData(response); })
					.catch((err) => {
						setError(err?.response?.data ? err.response.data.returnText : err.message);
					})
					.finally(() => { setLoading(false); });
			}

		} else {
			if (guid) {
				setLoading(true);
				getPdfApi(guid)
					.then((response) => { setPdfData(response); })
					.catch((err) => {
						setError(err?.response?.data ? err.response.data.returnText : err.message);
					})
					.finally(() => { setLoading(false); });

				return;
			}
		}
	}, []);

	if (loading) {
		return (
			<div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
				<Loader size="large" type="converging-spinner" />
			</div>
		);
	}

	return <PDFViewer data={pdfData} style={{ height: "100%" }} tools={tools} />;
};

export default PdfViewer;